import React from 'react'
import './Features.scss'
import Container from 'reactor/components/Grid/ContainerWithWidth'
import GridItem from 'reactor/components/Grid/GridItem'
import Heading from './../../../components/heading'

export default function Features({object, headingText}) {
    return (
        <div className="features">
            <Container  block={"true"}>
                <Heading title={headingText} />
            </Container>
            <Container>
                {object.map( (item, index) => (
                    <GridItem key={index} sm={4} xs={6}>
                        <div className="feature__item">
                            <div className="feature__item--image">
                                <img src={item.img} alt={item.title} className="" />
                            </div>
                            <div className="feature__item--caption">
                                <h4 className="feature__item--caption--title">{item.title}</h4>
                                <p className="feature__item--caption--content">{item.content}</p>
                            </div>
                        </div>
                    </GridItem>
                ))}
            </Container>
        </div>
    )
}